// extracted by mini-css-extract-plugin
module.exports = {"stickyFooter":"StickyFooter_stickyFooter__dO6N6","fullWidth":"StickyFooter_fullWidth__35qQE"};